module.exports = __webpack_public_path__ + "assets/img/favicon/apple-icon-120x120.a836b436ef240e11ea7601dcf05d9d59.png";